import { render } from "./ClientNavbar.vue?vue&type=template&id=314048ac&scoped=true"
import script from "./ClientNavbar.vue?vue&type=script&lang=js"
export * from "./ClientNavbar.vue?vue&type=script&lang=js"

import "./ClientNavbar.vue?vue&type=style&index=0&id=314048ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-314048ac"]])

export default __exports__